import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../shared';
import { LocationService, LoggingService } from '../services';
import { LocationSearchCacheKey } from '../contracts';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
    public isExternalUser: boolean;

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly locationService: LocationService,
        private readonly loggingService: LoggingService) {
    }

    public ngOnInit(): void {
        const isAuthorizeUser = this.authService.isLoggedIn;

        if (isAuthorizeUser) {
            this.authService.redirectToLastPage();

            const userId = this.authService.getUserPrincipalName();
            const regionCode = this.authService.getRegionCode();
            this.loggingService.LogEventLogin(userId, regionCode);
        }

        if (!this.authService.isRoleValid() || !this.authService.isClaimsValid()) {
            this.router.navigate(['access-denied']);
        }
        this.isExternalUser = this.authService.isExternalUser();
        if (this.authService.isOperator()) {
            this.isExternalUser = false;
        }

        this.locationService.removeLocationsToCache(LocationSearchCacheKey.Screening);
    }
}
